import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mapbox/mr-ui/icon';

class RenameInput extends React.PureComponent {
  inputRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = { toggled: false };
  }

  toggleRename = e => {
    e.preventDefault();
    this.setState({ toggled: true }, () => {
      this.inputRef.current.focus();
    });
  };

  onConfirm = () => {
    const { value, onChange } = this.props;
    this.setState(
      {
        toggled: false
      },
      () => {
        if (!value) onChange('Untitled');
      }
    );
  };

  onChange = e => {
    this.props.onChange(e.target.value);
  };

  onKeyDown = e => {
    switch (e.keyCode) {
      case 27: // ESC
      case 13: // RETURN
        e.target.blur();
        break;
      default:
        return;
    }
  };

  render() {
    const { toggled } = this.state;
    const { value, classList } = this.props;
    let field = (
      <span className={`flex-child wmax300 txt-truncate ${classList}`}>
        {value}
      </span>
    );

    let action = (
      <button
        test="toggle-rename"
        className="flex-child link link--gray ml6"
        title="Rename"
        onMouseDown={this.toggleRename}
      >
        <Icon name="pencil" />
      </button>
    );

    const containerProps = {
      className:
        'flex-parent flex-parent--center-cross flex-parent--space-between-main'
    };

    if (toggled) {
      field = (
        <input
          onKeyDown={this.onKeyDown}
          ref={this.inputRef}
          value={value}
          onBlur={this.onConfirm}
          onChange={this.onChange}
          style={{ backgroundColor: 'inherit' }}
          className={`txt-s input bg-white flex-child flex-child--grow`}
        />
      );

      action = (
        <button title="Confirm rename" className="flex-child link ml6">
          <Icon name="check" />
        </button>
      );
    }

    return (
      <div {...containerProps}>
        {field}
        <div className="flex-child">{action}</div>
      </div>
    );
  }
}

RenameInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classList: PropTypes.string
};

export { RenameInput };
